var $datepickers = [];

$(document).ready(function () {
    initializeDatepickers();
});

function initializeDatepickers() {
    // Get datepickers objects
    for (var i = 1; i <= 4; i++) {
        $datepickers[i - 1] = $(`#datetimepicker${i}`);
    }

    // Set options for each datetime picker
    $datepickers.map((datepicker, i) => {
        return datepicker.datetimepicker({
            format: 'DD-MM-YYYY',
            locale: window.moment.locale('en', {
                week: {dow: 1}
            }),
            useCurrent: (i % 2) ? false : true,
        })
    })
};

// Change max/min date in the other datepicker
function changeDate(index, newDate, isStartDate) {
    // Set min/max date for related datetimepicker
    (isStartDate) ? $datepickers[index - 1].data("DateTimePicker").maxDate(newDate) : $datepickers[index + 1].data("DateTimePicker").minDate(newDate);
}

function countDifferenceBetweenDates(index) {
    // Get selected radio button
    let dateType = $('input[name=radioPeriod]:checked').val();
    var stepType;

    if (dateType == "MONTHS") {
        stepType = "months";
    } else if (dateType == "DAYS") {
        stepType = "days";
    } else {
        stepType = "weeks";
    }

    var numberOfDays = 0;

    // Get number of days/weeks/months between date range
    if ($datepickers[index].data('date') && $datepickers[+index + 1].data('date')) {
        numberOfDays = dateRange($datepickers[index].data('date'), $datepickers[+index + 1].data('date'), stepType);
    }

    return numberOfDays;
}

// Get date range (how many days) between two dates
function dateRange(startDate, endDate, stepType) {
    if (!endDate) {
        endDate = startDate;
    }

    if (!startDate) {
        startDate = endDate;
    }

    var momentStart = window.moment(startDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
    momentStart = window.moment(momentStart).toArray();

    var momentEnd = window.moment(endDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
    momentEnd = window.moment(momentEnd).toArray();

    momentStart = window.moment(momentStart);
    momentEnd = window.moment(momentEnd);

    return Math.abs(momentEnd.diff(momentStart, stepType));
}

module.exports = {
    $datepickers: $datepickers,
    changeDate: changeDate,
    countDifferenceBetweenDates: countDifferenceBetweenDates,
    dateRange: dateRange,
};

